import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() isHome: boolean = false
  @Input() isInmuebles: boolean = false


  // CON PILLS
  isRetalkActive(): boolean {
    // Asumiendo que tus URLs de subítems son únicas y distinguibles
    const retalkSubItemsUrls = this.menuItems.find(item => item.id === 4)?.subMenu?.map(subItem => subItem.url) || [];
    return retalkSubItemsUrls.some(url => this.router.url.includes(url));
  }

  preventDefault(event: Event) {
    event.preventDefault();
  }

  toggleSubMenu(item: any): void {
    item.isOpen = !item.isOpen;
  }

  public getCurrentUrl(): string {
    return this.router.url;
  }


  menuItems = [
    { id: 0, label: 'quienes somos', url: '/quienes-somos' },
    { id: 1, label: 'inmuebles', url: '/inmuebles' },
    { id: 2, label: 'equipo', url: '/equipo' },
    { id: 3, label: 'sala de prensa', url: '/sala-de-prensa' },
    {
      id: 4,
      label: '#retalk',
      subMenu: [
        { label: '#podcast', url: '/retalk', active: false },
        { label: '#pills', url: '/pills', active: false }
      ],
      url: '/retalk',
      isOpen: false
    },
    { id: 5, label: 'casos de éxito', url: '/casos-exito' },
    { id: 6, label: 'esg', url: '/esg' },
    { id: 7, label: 'contacto', url: '/contacto' }
  ];

  // menuItems = [
  //   { id: 0, label: 'quienes somos', url: '/quienes-somos' },
  //   { id: 1, label: 'inmuebles', url: '/inmuebles' },
  //   { id: 2, label: 'equipo', url: '/equipo' },
  //   { id: 3, label: 'sala de prensa', url: '/sala-de-prensa' },
  //   { id: 4, label: '#retalk', url: '/retalk' },
  //   { id: 5, label: 'casos de éxito', url: '/casos-exito' },
  //   { id: 6, label: 'esg', url: '/esg' },
  //   { id: 7, label: 'contacto', url: '/contacto' }
  // ];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // menu sticky
    if (!this.isHome && !this.isInmuebles) {
      window.onscroll = function () {
        var nav = document.getElementById('header');
        if (window.pageYOffset > 200) {
          nav!.classList.add("sticky");
        } else {
          nav!.classList.add("sticky");
        }
      }
    }
  }

}
